import { Calendar, MapPin, Clock, ArrowRight, Bell } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import Countdown from "@/components/ateliers/Countdown";

export default function DatesCTA({ workshops, onRegister, onNotify }) {
  const hasWorkshops = workshops && workshops.length > 0;

  return (
    <section
      id="dates"
      data-testid="ateliers-dates"
      className="py-24 md:py-32 bg-[#FAF7F8] scroll-mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <Reveal>
            <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
              — Calendrier
            </span>
            <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05]">
              Prochaines dates
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-base text-[#5F6170] max-w-md">
              Les ateliers se déroulent en groupe restreint pour préserver la qualité
              du travail.
            </p>
          </Reveal>
        </div>

        {hasWorkshops ? (
          <div className="grid md:grid-cols-3 gap-6">
            {workshops.map((w, i) => (
              <Reveal key={w.id} delay={i * 0.08}>
                <article
                  data-testid={`ateliers-date-card-${i}`}
                  className="group h-full p-8 bg-white rounded-3xl border border-[#DDD7E2] hover:-translate-y-1 hover:border-[#C98FA3] hover:shadow-[0_20px_40px_rgb(40,71,184,0.08)] transition-all duration-300 flex flex-col"
                >
                  <div className="flex items-center justify-between mb-5">
                    <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-[#3A2E6E] font-medium">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#C98FA3]" />
                      {w.statut === "complet" ? "Complet" : "Places disponibles"}
                    </span>
                    <span className="text-xs text-[#5F6170]">
                      {w.places_restantes} places
                    </span>
                  </div>

                  {w.date_iso && (
                    <div className="mb-5">
                      <Countdown targetDate={w.date_iso} theme="light" />
                    </div>
                  )}

                  <h3 className="font-serif-display text-2xl text-[#1E1E2A] leading-tight">
                    {w.date_label}
                  </h3>

                  <ul className="mt-6 space-y-3 text-sm text-[#5F6170] flex-grow">
                    <li className="flex items-center gap-3">
                      <MapPin className="w-4 h-4 text-[#C98FA3]" /> {w.lieu}
                    </li>
                    <li className="flex items-center gap-3">
                      <Clock className="w-4 h-4 text-[#C98FA3]" /> {w.duree}
                    </li>
                    <li className="flex items-center gap-3">
                      <Calendar className="w-4 h-4 text-[#C98FA3]" /> Groupe restreint
                    </li>
                  </ul>

                  <button
                    onClick={() => onRegister(w)}
                    disabled={w.statut === "complet"}
                    data-testid={`ateliers-date-cta-${i}`}
                    className="mt-8 inline-flex items-center justify-between bg-[#2847B8] text-white hover:bg-[#3A2E6E] disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-300 rounded-full px-6 py-3 font-medium text-sm gap-2"
                  >
                    {w.statut === "complet" ? "Atelier complet" : "S'inscrire"}
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </button>
                </article>
              </Reveal>
            ))}
          </div>
        ) : (
          <div
            data-testid="ateliers-no-dates"
            className="p-12 bg-white rounded-3xl border border-[#DDD7E2] text-center"
          >
            <p className="text-base text-[#5F6170]">
              Les prochaines dates seront annoncées prochainement.
            </p>
          </div>
        )}

        <Reveal delay={0.3}>
          <div className="mt-14 p-8 md:p-10 rounded-3xl bg-[#F3EEF4] border border-[#DDD7E2] flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div>
              <p className="text-sm uppercase tracking-[0.2em] text-[#3A2E6E] font-medium">
                Vous hésitez ?
              </p>
              <p className="mt-2 text-lg text-[#1E1E2A] font-serif-display">
                Recevez les prochaines dates directement par email.
              </p>
            </div>
            <button
              onClick={onNotify}
              data-testid="ateliers-notify-cta"
              className="inline-flex items-center gap-2 bg-white border-2 border-[#C98FA3] text-[#3A2E6E] hover:bg-[#C98FA3] hover:text-white transition-all duration-300 rounded-full px-6 py-3 font-medium text-sm"
            >
              <Bell className="w-4 h-4" />
              Être informé des prochaines dates
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
